import { EMAIL_FILE_EXTENSIONS } from '@web/enums/EmailFileType';

interface PickFileOptions {
  accept?: string;
  onSelected: (file: File) => void;
}

export const EMAIL_IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp,image/gif';
export const EMAIL_FILE_ACCEPT = EMAIL_FILE_EXTENSIONS.map(
  (extension) => `.${extension}`,
).join(',');
export const V_CARD_IMAGE_ACCEPT = 'image/jpeg,image/png';
export const MICROSITE_DRAFT_LOGO_IMAGE_ACCEPT =
  'image/jpeg,image/png,image/svg+xml';
export const TAP_TAG_LOGO_IMAGE_ACCEPT = 'image/png';
export const TAP_TAG_CUSTOM_ARTWORK_IMAGE_ACCEPT = 'image/png';

export function pickFile({ accept, onSelected }: PickFileOptions): void {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = accept ?? '*';
  input.style.display = 'none';

  input.onchange = (event: Event) => {
    const files = (event.target as HTMLInputElement).files;
    if (files && files.length > 0) {
      onSelected(files[0]);
    }
    input.remove();
  };
  document.body.appendChild(input);
  input.click();
}
